module.exports =
{

  _init: function ()
  {
    console.log("init signups.js")
    APPLICATION._APPLICATION.processLinks('#signups', 'SocialTariff', 'signups')
  }

}